import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-primary fw-bold">Cookie Policy</h2>
      <p>
        This Cookie Policy explains how CompraPrice uses cookies and similar technologies to enhance your experience.
      </p>

      <h5 className="mt-4">1. What Are Cookies?</h5>
      <p>Cookies are small text files stored on your device that help us recognize you and remember your preferences.</p>

      <h5 className="mt-4">2. How We Use Cookies</h5>
      <ul>
        <li>To analyze site traffic</li>
        <li>To remember user preferences</li>
        <li>To personalize content and ads</li>
      </ul>

      <h5 className="mt-4">3. Managing Cookies</h5>
      <p>You can control or delete cookies through your browser settings.</p>

      <p className="mt-4">By continuing to use our site, you agree to our use of cookies.</p>
    </div>
  );
};

export default CookiePolicy;
